import { Stack, Grid, Typography, Box, IconButton } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as Comment } from 'common/assets/images/comment.svg';
import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import { RootState } from 'common/store/AppStore';
import { setIsOpenInvententoryCommentDrawer } from 'common/store/reducer/regulationInventoryReducer';
import { dateFullYearFormat, toSentenceCase } from 'common/utils/utilFunctions';

import TaskComment from 'features/RiskProfile/Taxonomy/RelationMapping/MappingDetail/Tasks/TaskComment';

import { IRegHeadersType } from '../../api/type-def';

import detailsStyles from './RegHeader.module.scss';

const RegHeader = (props: any) => {
	const dispatch = useDispatch();

	const { headerItems, data, taskId, title } = props;
	const { commentIconColor, drawerCloseIconColor } = detailsStyles;
	const isCommentOpen = useSelector(
		(state: RootState) =>
			state.regulationInventory.isOpenInvententoryCommentDrawer,
	);
	const commentCount = useSelector(
		(state: RootState) => state.regulationInventory.commentCount,
	);

	const loggedInUser: any = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);

	const onClickComment = () => {
		dispatch(setIsOpenInvententoryCommentDrawer(true));
	};

	const handleDrawerChange = () => {
		dispatch(setIsOpenInvententoryCommentDrawer(false));
	};
	return (
		<Stack>
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="flex-start"
					spacing={3}
				>
					{headerItems?.map((item: IRegHeadersType) => (
						<Typography
							key={item.key}
							className={detailsStyles['summary-detail-info']}
						>
							{toSentenceCase(item?.name)}:{' '}
							{(data &&
								(dateFullYearFormat(data[item?.key]) !== String('Invalid Date')
									? dateFullYearFormat(data[item?.key])
									: data[item?.key])) ||
								'--'}
						</Typography>
					))}
					{taskId && (
						<ButtonComp
							disabled={data.assignedUserId !== loggedInUser?.userId}
							btnType="tertiary"
							startIcon={<Comment fill={commentIconColor} />}
							clickHandler={onClickComment}
							compClass={detailsStyles['comments-btn']}
						>
							Comments
						</ButtonComp>
					)}
				</Stack>
			</Grid>
			<SideDrawer
				className={detailsStyles['comment-side-drawer']}
				drawerState={isCommentOpen}
			>
				<Box
					data-testid="side-drawer-comment"
					className={detailsStyles['detailed-container']}
					role="presentation"
				>
					<div className={detailsStyles['control-lay-text-bg']}>
						<Stack
							direction="row"
							justifyContent="flex-end"
							spacing={2}
							data-testid="close-button-stack"
						>
							<IconButton
								size="large"
								onClick={handleDrawerChange}
								data-testid="close-button-icon"
								className={detailsStyles['fileupload-close']}
							>
								<DrawerClose fill={drawerCloseIconColor} />
							</IconButton>
						</Stack>

						<Box className={detailsStyles['fileupload-text-box']}>
							<Typography className={detailsStyles['sidedrawer-title']}>
								{`Comments (${commentCount})`}
							</Typography>
							<Typography className={detailsStyles['sidedrawer-subtitle']}>
								{title && title.split(' ').slice(0, 20).join(' ')}{' '}
								{title && title.split(' ').length > 20 ? '...' : ''}
							</Typography>
						</Box>
					</div>
					<Grid
						className={detailsStyles['comment-background']}
						item
						xs={12}
						sm={12}
						md={12}
						xl={12}
						lg={12}
						p={1}
					>
						<TaskComment type="normal" taskId={taskId} />
					</Grid>
				</Box>
			</SideDrawer>
		</Stack>
	);
};

export default RegHeader;
